<template>
    <div class="wrap" :class="{ fullscreen: fullscreen && isMobile }">
        <img :src="imageBaseUrl + '/api/booths/' + boothName +'/image?sid=' + sid" :alt="'Booth-'+boothName" :class="{portrait: !orientation}" class="video">
        <video-overlay 
            :highlight-items="highlight"
            :video-elements="controller"
            :booth-name='boothName'
            @open-modal="openModal"
            @back="handleBack"
            ref="overlay"
        />
        <div class="icon-wrap" :class="{ fullscreen }">
            <div @click="handleFullScreen" v-if="!orientation && isMobile">
                <span class="material-icons" v-tooltip="'Fullscreen mode'">{{fullscreen ? 'fullscreen_exit' : 'fullscreen'}}</span>
            </div>
            <div @mousedown="handleHiglight(true)" @touchstart="handleHiglight(true)" @mouseup="handleHiglight(false)" @touchend="handleHiglight(false)" v-tooltip="'Higlight items'">
                <span class="material-icons">visibility</span>
            </div>
        </div>
    </div>
</template>

<script>
import VideoOverlay from './VideoOverlay'
import isMobileMixin from '../../mixins/isMobileMixin'
export default {
    components: {
        VideoOverlay
    },
    props: {
        orientation: {
            type: Boolean,
            default: false
        },
        controller: {
            type: Array,
        },
        boothName: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            highlight: false,
            fullscreen: false,
            sid: localStorage.getItem('sid'),
            imageBaseUrl: process.env.VUE_APP_VIDEO_BASE
        }
    },
    mounted() {
    },
    mixins: [isMobileMixin],
    methods: {
        handleHiglight (val) {
            this.highlight = val
        },
        handleFullScreen () {
            this.fullscreen = !this.fullscreen
        },
        openModal (link) {
            this.$emit('open-modal', link)
        },
        handleBack () {
            this.$router.push('/floor/1?skip=true')
        },
    }
}
</script>

<style scoped lang="scss">
.wrap {
    position: relative;
    &.fullscreen {
        width: max-content;
        .video {
            // remove if video not streched
            max-height: var(--page-height-portrait) !important;
        }
        .portrait {
            height: 100%;
            width: auto;
        }
    }
}
.cancel {
    pointer-events: none;
}
.icon-wrap {
    position: fixed;
    top: calc(3% + var(--nav-height));
    right: 3%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    &.fullscreen {
        position: fixed;
        top: calc(3% + var(--nav-height));
    }
    div {
        border-radius: 50%;
        user-select: none;
        background: #ffffff93;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px;
        margin: 0 5px;
    }
}
</style>
